import { Link } from "react-router-dom";

export default function BuyPage() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
      <h1 className="font-heading text-3xl md:text-4xl font-semibold text-accent-800 mb-4">
        Complete Your Order
      </h1>
      <p className="text-foreground-600 text-center max-w-md">
        The checkout page is being built. Come back soon!
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-lg font-medium hover:bg-secondary-500 transition-colors"
      >
        Back to Home
        <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
      </Link>
    </div>
  );
}